import { ClientEntity } from "@jackfruit/common"
import { SagaIterator } from "redux-saga"
import { call, select } from "redux-saga/effects"
import { VNZService } from "~/components/cloud-provider/vnz/service/VNZService"
import { PrinticularApi } from "~/services/PrinticularApi"
import { clientsSelector } from "../state/client"
import { getApi } from "./api"

export function* getVnzService(): SagaIterator<VNZService> {
  const printicularApi: PrinticularApi = yield call(getApi)
  const clients: ClientEntity[] = yield select(clientsSelector.selectAll)
  const client = clients[0]

  const { verizonApiUrl, verizonAuthUrl, verizonCloudFrontProxyUrl } = client

  return new VNZService(
    verizonApiUrl,
    verizonAuthUrl,
    verizonCloudFrontProxyUrl,
    printicularApi
  )
}
